import { Link } from 'gatsby'
import React from 'react'
import logo from '../images/logo/monogram-color.svg'
import DocSearch from './DocSearch'
import CSS from './TopNav.module.scss'

const TopNav = (props: Props) => {
  const { compact } = props

  return (
    <nav className={CSS.root}>
      <Link to='/'>
        <img src={logo} className={CSS.logo} />
      </Link>

      {!compact ? (
        <Link to='/' className={CSS.brand}>
          Playbook
        </Link>
      ) : null}

      <span className={CSS.search}>
        <DocSearch inputProps={{ className: CSS.searchInput }} />
      </span>
    </nav>
  )
}

TopNav.defaultProps = {
  compact: false
}

interface Props {
  compact?: boolean
}

export default TopNav
